import { Body, Controller, Get, Param, Post } from '@nestjs/common';
import { ApplicationExceptionHandler } from "packages/libs/backend-utils/src/";
import { ApaSizeMatrixService } from './apa-size-matrix.service';
import { ApaSizeMatrixResponseModel, CommonResponseModel } from '@project-management-system/shared-models';
import { ApiBody } from '@nestjs/swagger';
import { ApaSizeMatrixBDto } from './dto/apa-matrix.dto';

@Controller('/apa_size_matrix')
export class ApaSizeMatrixController {
    constructor(
        private Service: ApaSizeMatrixService,
        private readonly applicationExceptionhandler: ApplicationExceptionHandler
        ) { }

@ApiBody({ type: ApaSizeMatrixBDto })
@Post('/createApaSizeMatrix')
async createApaSizeMatrix(@Body() req: any): Promise<ApaSizeMatrixResponseModel> {
  try {
    return await this.Service.createApaSizeMatrix(req,false)
  } catch(error) {
    return this.applicationExceptionhandler.returnException(ApaSizeMatrixResponseModel,error)
  }
}


@ApiBody({ type: ApaSizeMatrixBDto })
@Post('/updateApaSizeMatrix')
async updateApaSizeMatrix(@Body() req: any): Promise<ApaSizeMatrixResponseModel> {
  try {
    return await this.Service.updateApaSizeMatrix(req,true)
  } catch(error) {
    return this.applicationExceptionhandler.returnException(ApaSizeMatrixResponseModel,error)
  }
}


    @Get('/getAllApaSizeData/:styleNumber')
    async getAllApaSizeData(@Param('styleNumber') styleNumber: string) : Promise<ApaSizeMatrixResponseModel>{
        try{
            return await this.Service.getAllApaSizeData(styleNumber)
        }catch(error){
            return this.applicationExceptionhandler.returnException(ApaSizeMatrixResponseModel, error);
        }
    }

    
    @Post('/getAllApaSizeViewData')
    async getAllApaSizeViewData() : Promise<ApaSizeMatrixResponseModel>{
        try{
            return await this.Service.getAllApaSizeViewData()
        }catch(error){
            return this.applicationExceptionhandler.returnException(ApaSizeMatrixResponseModel, error);
        }
    }

}
